module.exports = __webpack_public_path__ + "media/images/lig/products/lig-product-04-fd14bb50334132d2ef2707844645a15d.jpg";